var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('shipping-info-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var campaign = ref.campaign;
var proposal = ref.proposal;
var contact = ref.contact;
var proposalStep = ref.proposalStep;
var patchProposalStep = ref.patchProposalStep;
var goNextStep = ref.goNextStep;
var goPreviousStep = ref.goPreviousStep;
var isLoading = ref.isLoading;
var isCompletingProposal = ref.isCompletingProposal;
var loadingCountries = ref.loadingCountries;
var loadingProvinces = ref.loadingProvinces;
var countries = ref.countries;
var provinces = ref.provinces;
var countryUpdated = ref.countryUpdated;
var errors = ref.errors;
var errorMessage = ref.errorMessage;
return [_c('proposal-shipping-info-view',{attrs:{"campaign":campaign,"proposal-step":proposalStep,"proposal":proposal,"contact":contact,"countries":countries,"provinces":provinces,"is-loading":isLoading,"errors":errors,"error-message":errorMessage,"is-completing-proposal":isCompletingProposal,"loading-countries":loadingCountries,"loading-provinces":loadingProvinces},on:{"country-updated":countryUpdated,"go-next-step":goNextStep,"go-previous-step":goPreviousStep,"patch-step":patchProposalStep,"chountry-updated":countryUpdated}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }